import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleIcon',
  props: {
  name: { required: true, type: String },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: require(`@/assets/img/${props.name}.svg`),
    alt: `${props.name} icon`
  }, null, 8 /* PROPS */, _hoisted_1))
}
}

})